/**
 * @Author: shenyi
 * @Date:   2023-08-11 14:50:27
 * @Last Modified by:   shenyi
 * @Last Modified time: 2023-08-25 14:31:40
 */
export default class User {
  /**
   * 用户ID
   */
  public userId: string;
  /**
   * 用户登录名（大概率与userCode一致）
   */
  public username: string;
  /**
   * 真实姓名(需考虑少数民族的名称超长)
   */
  public fullName: string;
  /**
   * 用户头像（非证件照)
   */
  public avatar: string;
  /**
   * 用户编号（学生学号，教师教工号）
   */
  public no: string;
  /**
   * 是否隐藏退出按钮
   */
  public hiddenLogout: boolean;
  /**
   * 是否显示返回第三方工作台
   */
  public showBackToOther: boolean;
  constructor({
    userId = "",
    username = "",
    fullName = "",
    avatar = "",
    no = "",
    hiddenLogout=false,
    showBackToOther=false
  } = {}) {
    this.userId = userId;
    this.username = username;
    this.fullName = fullName;
    this.avatar = avatar;
    this.no = no;
    this.hiddenLogout=hiddenLogout;
    this.showBackToOther=showBackToOther
  }
}
